module.exports = __webpack_public_path__ + "static/media/arrow-down-stroke.6d31ba4d.svg";